import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { ToolCallEvent } from "@/hooks/useAgentChat";
import { toolStreamingI18nKey } from "@/lib/chat-utils";

interface InlineToolEventProps {
  toolCall: ToolCallEvent;
}

/**
 * Mid-stream tool call indicator badge.
 *
 * Shows the active tool as an animated Badge while the tool call
 * is in progress. Disappears when tool-call-complete is received.
 */
export function InlineToolEvent({ toolCall }: InlineToolEventProps) {
  const { t } = useTranslation();
  const displayLabel = t(toolStreamingI18nKey(toolCall.toolName));

  return (
    <Badge
      variant="outline"
      role="status"
      aria-label={displayLabel}
      className="animate-in fade-in slide-in-from-bottom-1 duration-200 gap-1"
    >
      <Loader2 className="h-3 w-3 animate-spin" />
      <span className="text-xs font-normal">{displayLabel}</span>
    </Badge>
  );
}
